<template>
  <header-bar id="mine-bar">
    <div id="mine-header">
      <img class="mine-header-icon" src="../../assets/detail.png" alt="" v-show="false">

      <div class="mine-header-username">
        <span>会员名：</span>{{ username }}
        <div class="mine-code-scanning" @click="showCode">
          <canvas id="msg"></canvas>
        </div>
      </div>

    </div>

    <div id="mine-setting">
      <div class="mine-setting-item stamp" style="margin-top: 0;position: relative" @click="memberProfileData">
        <img class="mine-stamp-icon" src="../../assets/yakult-stamp-icon.png"/>
        <div class="mine-stamp-info-item">
          <span class="mine-content" style="margin-left: 0;line-height: normal;font-weight: bold;margin-top: 0">会员编号:{{
              memberNo
            }}</span>
          <div class="mine-stamp-logo">
            <img src="../../assets/yakult-stamp.png"/>
            <div>={{ stamp }}</div>
          </div>

          <div style="margin-left: 6px;font-weight: bold">我的印花</div>
        </div>
        <div class="mine-order-count" style="bottom: 2rem">上个月截止到当前购买排数： {{ orderCount }}</div>
        <div class="mine-order-count">上个月截止到当前购买天数： {{ orderNum }}</div>

        <img class="mine-setting-item-next" src="../../assets/common_next.png" alt="">
      </div>

      <div v-if="activityOpenStatus" class="mine-setting-item activity">
        <div style="width: 90%;">
          <div class="title-content">{{ activityTitle }}</div>
          <div class="activity-detail-box">
            <div class="activity-detail" @click="viewActivityDetail">查看活动详情</div>
          </div>
          <div class="text-content">活动时间：{{ activityTimeStr }}</div>
          <!-- <div class="text-content">
            活动期间内购买天数≥{{needPurchaseDays}}天，购买排数≥{{needPurchaseQuantity}}支即可领取奖励一份，先到先得。奖励在活动结束后统一发放。
          </div> -->
          <div class="text-content">
            {{ activityContent }}
          </div>
          <div class="text-content">
            可报名领取次数：{{ availableCount }}次
          </div>
          <div class="text-content">
            已报名领取次数：{{ receivedCount }}次
          </div>

          <template v-if="activityQuotaFull && (canParticipate || !qualified)">
            <div class="disable-award">
                <span
                    style="color: white;font-size: 120%;font-weight: bold;letter-spacing: 7rpx;">报名人数已满，期待您的下次参与</span>
            </div>
          </template>
          <template v-if="!activityQuotaFull">
            <div v-if="canParticipate"
                 class="award"
                 @click="receiveRewards">
              <span style="color: white;font-size: 120%;font-weight: bold;letter-spacing: 7rpx;">可报名领取奖励</span>
            </div>
            <div v-if="!qualified" class="disable-award">
                <span
                    style="color: white;font-size: 120%;font-weight: bold;letter-spacing: 7rpx;">条件未满足，暂不能领取</span>
            </div>
          </template>

          <template v-if="received">
            <div class="title-content">活动报名信息</div>
            <div v-for="(item, index) in receiptInfoList" :key="index" class="receipt-info">
              <div class="receipt-info-item">
                报名信息{{ index + 1 }}：
              </div>
              <div class="receipt-info-item">
                <span class="label">收货人：</span>
                <span class="value">{{ item.consignee }}</span>
              </div>
              <div class="receipt-info-item">
                <span class="label">手机号：</span>
                <span class="value">{{ item.mobile }}</span>
              </div>
              <div class="receipt-info-item">
                <span class="label">收货地址：</span>
                <span class="value">{{ item.city }}{{ item.area }}{{ item.address }}</span>
              </div>
              <div class="line"></div>
            </div>
          </template>
          <!--<div class="text-content">您当前进度：</div>
          <div class="text-content">
              <span>
                购买天数：{{ purchaseDays }}天/{{ needPurchaseDays }}天
              </span>
              <span :class="{'span-content': remainingPurchaseDays > 0}">
                  （{{ remainingPurchaseDays > 0 ? "还差" + remainingPurchaseDays + "天" : "满足" }}）
              </span>
          </div>-->
          <!--                    <div class="text-content">-->
          <!--                        购买排数：{{ totalPurchaseQuantity }}排/{{ needPurchaseQuantity }}排；其中{{specifiedName}} {{ specifiedPurchaseQuantity }}排；-->
          <!--                    </div>-->
          <!-- <div class="text-content">
            购买排数：原味10支装（{{totalPurchaseQuantity}}排/{{needPurchaseQuantity}}排）；500亿0蔗糖或青提味5支装（{{specifiedPurchaseQuantity}}排/{{needSpecifiedPurchaseQuantity}}排）；
          </div>
          <div class="text-content">
              <span :class="{'span-content': remainingPurchaseQuantity > 0 || remainingSpecifiedPurchaseQuantity > 0}">
                  {{ purchaseQuantityProgress }}
              </span>
          </div> -->
          <!-- <div class="text-content">
                购买支数：任意口味（{{totalPurchaseQuantity}}支/{{needPurchaseQuantity}}支）
            </div>
            <div class="text-content">
                <span :class="{'span-content': remainingPurchaseQuantity > 0 }">
                    {{ purchaseQuantityProgress }}
                </span>
            </div>

                   <template v-if="received">
                     <div class="title-content">您已报名领取，感谢您的参与！</div>
                     <div class="receipt-info" v-for="(item, index) in receiptInfoList" :key="index">
                       <div class="receipt-info-item">
                         您报名填写的收货信息如下：
                       </div>
                       <div class="receipt-info-item">
                         <span class="label">收货人：</span>
                         <span class="value">{{ item.consignee }}</span>
                       </div>
                       <div class="receipt-info-item">
                         <span class="label">手机号：</span>
                         <span class="value">{{ item.mobile }}</span>
                       </div>
                       <div class="receipt-info-item">
                         <span class="label">收货地址：</span>
                         <span class="value">{{ item.city }}{{ item.area }}{{ item.address }}</span>
                       </div>
                     </div>
                   </template>
                   <template v-else>
                     <template v-if="activityQuotaFull">
                       <div class="disable-award">
                         <span
                             style="color: white;font-size: 120%;font-weight: bold;letter-spacing: 7rpx;">报名人数已满，期待您的下次参与</span>
                       </div>
                     </template>
                     <template v-else>
                       <div v-if="qualified && !activityQuotaFull"
                            class="award"
                            @click="receiveRewards">
                         <span style="color: white;font-size: 120%;font-weight: bold;letter-spacing: 7rpx;">可报名领取奖励</span>
                       </div>
                       <div v-else class="disable-award">
                         <span
                             style="color: white;font-size: 120%;font-weight: bold;letter-spacing: 7rpx;">条件未满足，暂不能领取</span>
                       </div>
                     </template>
                   </template> -->

        </div>
      </div>

      <div class="mine-setting-item" @click="memberPrintingDetail">
                    <span class="mine-content">
                        会员印花详细
                    </span>

        <img class="mine-setting-item-next" src="../../assets/common_next.png" alt="">
      </div>

<!--      <div class="mine-setting-item" @click="memberStampExchange">-->
<!--                    <span class="mine-content">-->
<!--                        印花兑换礼品-->
<!--                    </span>-->

<!--        <img class="mine-setting-item-next" src="../../assets/common_next.png" alt="">-->
<!--      </div>-->

      <div class="mine-setting-item" @click="memberReceiveAddress">
                    <span class="mine-content">
                        收货地址
                    </span>

        <img class="mine-setting-item-next" src="../../assets/common_next.png" alt="">
      </div>

      <div class="logout"
           @click="logout">
                    <span class="mine-content">
                        退出登录
                    </span>
      </div>
    </div>
    <div id="mine"></div>

    <exchange-prize-dialog v-if="precautionsDialogVisible" width="80%" class="precautions-dialog">
      <div class="precautions-title">注意事项</div>
      <div class="precautions-context">① 奖励领取完成后，需要等活动结束再由本公司统一安排发放。</div>
      <div class="precautions-context">② 本次活动奖品仅限广州益力多公司宅配覆盖的10个城市可领取。</div>
      <div class="precautions-tip-button">
        <button class="precautions-tip-cancel" @click="cancelReceiveRewards">放弃领取</button>
        <button class="precautions-tip-ok" @click="readAlready">确认并填写收货信息</button>
      </div>
    </exchange-prize-dialog>

<!--    <exchange-prize-dialog v-if="questionDialogVisible" width="80%" class="precautions-dialog">-->
<!--      <div class="precautions-title">关于免疫力的科普及回答</div>-->
<!--      <div class="precautions-context">Q: 益力多水蜜桃味的产品特征是什么？?</div>-->
<!--      <div class="precautions-context">A: 每瓶含100亿个活性乳酸菌，同时添加了高铁</div>-->
<!--      <div class="precautions-tip-button" style="display: flex;justify-content: center">-->
<!--        <button class="precautions-tip-ok" @click="readAlready">已阅读</button>-->
<!--      </div>-->
<!--    </exchange-prize-dialog>-->

    <exchange-prize-dialog v-if="tipDialogVisible" class="tip-dialog" width="80%">
      <div class="tip-title">提示</div>
      <div class="tip-context">{{ tipMessage }}</div>
      <div class="tip-button">
        <button class="tip-ok" @click="handleTipOk">确认</button>
      </div>
    </exchange-prize-dialog>

    <div v-show="isCode" id="mine-code" @click="close">
      <div class="code-box">
        <canvas id="msgCode"></canvas>
      </div>
      <div class="mine-code-miss">益力多姐姐扫此处二维码进行印花录入</div>
    </div>
  </header-bar>

</template>

<script>

import HeaderBar from "../../components/HeaderBar";
import QRCode from 'qrcode'
import {memberDetail} from "../../api/Member";
import ExchangePrizeDialog from "@/components/ExchangePrizeDialog";
import {ActivityPermissionVerification, GetActivityPersonalDetail} from "../../api/Activity";

export default {
  name: "Mine",
  components: {
    HeaderBar,
    // eslint-disable-next-line vue/no-unused-components
    QRCode,
    ExchangePrizeDialog
  },

  data() {
    return {
      memberNo: '',
      username: '',
      stamp: '0',
      isCode: false,
      orderCount: 0,//购买排数
      orderNum: 0,//购买次数
      activityOpenStatus: false,
      activityStartTime: null,
      activityEndTime: null,
      purchaseDays: 0,
      needPurchaseDays: 0,
      remainingPurchaseDays: 0,
      totalPurchaseQuantity: 0,
      needPurchaseQuantity: 0,
      remainingPurchaseQuantity: 0,
      specifiedPurchaseQuantity: 0,
      needSpecifiedPurchaseQuantity: 0,
      remainingSpecifiedPurchaseQuantity: 0,
      precautionsDialogVisible: false,
      questionDialogVisible: false,
      qualified: false,
      received: false,
      consignee: '',
      mobile: '',
      city: '',
      area: '',
      address: '',
      tipDialogVisible: false,
      tipMessage: '',
      activityTitle: '',
      activityTimeStr: '',
      activityQuotaFull: true,
      specifiedName: '',
      activityContent: '',
      availableCount: 0,
      receivedCount: 0,
      canParticipate: false,
      receiptInfoList: []
    }
  },

  computed: {
    purchaseQuantityProgress() {
      // if (this.remainingPurchaseQuantity > this.remainingSpecifiedPurchaseQuantity && this.remainingSpecifiedPurchaseQuantity > 0) {
      //     return `（还差${ this.remainingPurchaseQuantity }排，其中青提味${ this.remainingSpecifiedPurchaseQuantity }排）`
      // } else if (this.remainingPurchaseQuantity > this.remainingSpecifiedPurchaseQuantity && this.remainingSpecifiedPurchaseQuantity <= 0 && this.remainingPurchaseQuantity > 0) {
      //     return `（还差${ this.remainingPurchaseQuantity }排）`
      // } else if (this.remainingSpecifiedPurchaseQuantity >= this.remainingPurchaseQuantity && this.remainingSpecifiedPurchaseQuantity > 0) {
      //     return `（还差青提味${ this.remainingSpecifiedPurchaseQuantity }排）`
      // } else {
      //     return `（满足）`
      // }

      // if (this.remainingPurchaseQuantity > this.remainingSpecifiedPurchaseQuantity && this.remainingSpecifiedPurchaseQuantity > 0) {
      //     return `（还差原味10支装${ this.remainingPurchaseQuantity }排，500亿0蔗糖或青提味5支装${ this.remainingSpecifiedPurchaseQuantity }排）`
      // } else if (this.remainingPurchaseQuantity > this.remainingSpecifiedPurchaseQuantity && this.remainingSpecifiedPurchaseQuantity <= 0 && this.remainingPurchaseQuantity > 0) {
      //     return `（还差原味10支装${ this.remainingPurchaseQuantity }排）`
      // } else if (this.remainingSpecifiedPurchaseQuantity >= this.remainingPurchaseQuantity && this.remainingSpecifiedPurchaseQuantity > 0) {
      //     return `（还差500亿0蔗糖或青提味5支装${ this.remainingSpecifiedPurchaseQuantity }排）`
      // } else {
      //     return `（满足）`
      // }
      if (this.remainingPurchaseQuantity > 0) {
        return `（还差任意口味${this.remainingPurchaseQuantity}支）`
      } else {
        return `（满足）`
      }
    }
  },

  mounted() {
    this.memberDetail();
    this.requestActivityPersonalDetail();
  },

  methods: {
    requestActivityPersonalDetail() {
      GetActivityPersonalDetail().then((response) => {
        if (response.code === this.$API_CODE.OK) {
          this.activityOpenStatus = response.data.activityOpenStatus;
          if (response.data.activityOpenStatus) {
            this.purchaseDays = response.data.purchaseDays;
            this.remainingPurchaseDays = response.data.remainingPurchaseDays;
            this.needPurchaseDays = response.data.needPurchaseDays;
            this.totalPurchaseQuantity = response.data.totalPurchaseQuantity;
            this.remainingPurchaseQuantity = response.data.remainingPurchaseQuantity;
            this.needPurchaseQuantity = response.data.needPurchaseQuantity;
            this.specifiedPurchaseQuantity = response.data.specifiedPurchaseQuantity;
            this.remainingSpecifiedPurchaseQuantity = response.data.remainingSpecifiedPurchaseQuantity;
            this.needSpecifiedPurchaseQuantity = response.data.needSpecifiedPurchaseQuantity;
            this.qualified = response.data.qualified;
            this.received = response.data.received;
            this.activityTitle = response.data.activityTitle;
            this.activityTimeStr = response.data.activityTimeStr;
            this.activityQuotaFull = response.data.activityQuotaFull;
            this.specifiedName = response.data.specifiedName;
            this.activityContent = response.data.activityContent;
            this.availableCount = response.data.availableCount;
            this.receivedCount = response.data.receivedCount;
            this.canParticipate = response.data.canParticipate;
            if (this.received) {
              this.receiptInfoList = response.data.receiptInfoList;
              // this.consignee = response.data.receiptInfo.consignee;
              // this.mobile = response.data.receiptInfo.mobile;
              // this.city = response.data.receiptInfo.city;
              // this.area = response.data.receiptInfo.area;
              // this.address = response.data.receiptInfo.address;
            }
          }
        }
      })
    },

    receiveRewards() {
      console.log('领取奖励');
      this.precautionsDialogVisible = true
    },

    cancelReceiveRewards() {
      this.precautionsDialogVisible = false
    },

    confirmReceiveRewards() {
      this.precautionsDialogVisible = false;
      this.questionDialogVisible = true;
    },

    readAlready() {
      ActivityPermissionVerification().then((response) => {
        if (response.code === this.$API_CODE.OK) {
          this.$router.push({path: '/activityAddressAdd'})
        } else {
          this.tipDialogVisible = true;
          this.tipMessage = response.message;
        }
      })
    },

    handleTipOk() {
      this.tipDialogVisible = false;
    },

    viewActivityDetail() {
      this.$router.push({path: '/activity'})
    },

    memberProfileData() {
      this.$router.push({path: '/memberEditInfo'})
    },

    memberPrintingDetail() {
      this.$router.push({path: '/memberPrintingDetail'})
    },

    memberStampExchange() {
      this.$router.push({path: '/stampExchange'})
    },

    memberReceiveAddress() {
      this.$router.push({path: '/addressList'})
    },

    logout() {
      this.$store.dispatch('Logout')
          .then(() => {
            this.$router.go(-1)
          })
    },

    close() {
      this.isCode = false;
    },
    showCode() {
      this.isCode = true;
      this.memberDetail();
    },

    memberDetail() {
      memberDetail()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              this.username = response.data.username;
              this.memberNo = response.data.memberNo;
              this.stamp = response.data.stamp;
              this.orderCount = response.data.orderCount;
              this.orderNum = response.data.orderNum;

              var msg = document.getElementById('msg');
              var code = document.getElementById('msgCode');
              // 将获取到的数据（val）画到msg（canvas）上
              QRCode.toCanvas(msg, this.memberNo, function (error) {
                console.log(error)
              });
              QRCode.toCanvas(code, this.memberNo, function (error) {
                console.log(error)
              })
            }
          })
    }
  }
}
</script>

<style lang="scss" scoped>
#mine-bar {
  width: 100%;
  height: 100%;
  background: #fdf9f7;
  position: absolute;

  #mine-header {
    width: auto;
    height: 6rem;
    background: url("../../assets/detail.png");
    background-size: 100% 6rem;

    .mine-header-icon {
      width: 39px;
      height: 57px;
      float: left;
      margin-left: 30px;
      margin-top: 30px;
    }

    .mine-header-username {
      float: right;
      margin-right: 20px;
      color: white;
      font-size: 1rem;
      font-weight: bold;
      line-height: 6rem;
      /*div {*/
      /*margin-bottom: 3px;*/
      /*text-align: left;*/
      /*max-width: 200px;*/
      /*word-wrap: break-word;word-break: break-all;overflow: hidden;*/
      /*}*/

      .mine-code-scanning {
        margin: 0 auto;
        width: 30px;
        height: 30px;
        line-height: 90px;
        float: right;
        margin-top: 0.8rem;
        margin-left: 5px;

        canvas {
          width: 30px !important;
          height: 30px !important;
        }
      }

    }
  }

  #mine-code {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 100;

    .code-box {
      margin: 150px 10px auto;

      canvas {
        width: 150px !important;
        height: 150px !important;
      }
    }

    .mine-code-scanning {
      margin: 0 auto;
      width: 30px;
      height: 30px;
    }

    .mine-code-miss {
      font-size: 1rem;
      font-weight: bold;
      margin-top: 10px;
      color: #ffffff;
    }
  }

  #mine-setting {
    clear: both;


    .mine-setting-item {
      height: 3rem;
      background: white;
      border-bottom: 1px solid #dddddd;
      border-top: 1px solid #dddddd;
      margin-top: 10px;
      font-size: 1rem;

      .mine-content {
        float: left;
        margin-left: 1.5rem;
        margin-top: 1rem;
      }

      .mine-setting-item-next {
        float: right;
        margin-right: 1.5rem;
        margin-top: 1rem;
      }

      .mine-stamp-icon {
        width: 55px;
        height: 65px;
        float: left;
        margin-left: 30px;
        margin-top: 10px;
      }

      .mine-stamp-info-item {
        float: left;
        margin-left: 10px;
        text-align: left;
        color: #ea2d53;
        position: relative;
        margin-top: 10px;

        .mine-stamp-logo {

          img {
            width: 75px;
            height: 115px;
          }

          div {
            position: absolute;
            top: 50%;
            left: 100%;
            font-weight: bold;
            font-size: 2.8rem;
            width: 11rem;
            line-height: 3rem;
            margin-left: -2.5rem;
            word-break: break-all
          }
        }
      }

      .mine-order-count {
        position: absolute;
        bottom: 0.5rem;
        right: 0.5rem;
        width: 70%;
        text-align: left;
        color: #ea2d53;
      }

    }

    .stamp {
      height: 15rem;
    }
  }

  .logout {
    background: #ea2d53;
    height: 3rem;
    margin-top: 40px;
    line-height: 3rem;
    color: white;
    margin-left: 35px;
    margin-right: 35px;
    border-radius: 5px;
    font-size: 1rem;
  }


  #mine {
    height: 8rem;
  }
}

#mine-bar #mine-setting .activity {
  display: flex; /* 启用 Flex 布局 */
  justify-content: center; /* 水平居中 */
  height: auto;
  padding: 10px;
}

#mine-bar #mine-setting .title-content {
  height: auto;
  text-align: center;
  padding: 6px;
  background-color: #ea2d53;
  letter-spacing: 2px; /* 字间距 */
  color: #ffffff;
  font-weight: bold;
  font-size: 18px;
  margin-top: 0.8rem;
}

#mine-bar #mine-setting .activity-detail-box {
  display: flex;
  flex-direction: column; /* 改为垂直布局 */
  align-items: center; /* 水平居中 */
  justify-content: center; /* 垂直居中 */
  width: 100%;
}

#mine-bar #mine-setting .activity-detail {
  /* background-color: #e82e53;
  color: white;
  font-size: 28rpx;
  padding: 12rpx 24rpx;
  border-radius: 8rpx;
  text-align: center;
  margin: 16rpx auto;
  display: inline-block;
  transition: all 0.3s ease; */
  color: #1989fa;
  text-decoration: underline;
  font-size: 16px;
  margin-top: 5px;
  padding: 5px 0;
}

#mine-bar #mine-setting .text-content {
  color: #ea2d53; /* 红色文字 */
  letter-spacing: 1px; /* 字间距 */
  font-weight: bold;
  font-size: 15px;
  text-align: left;
  line-height: 22px;

  .span-content {
    color: #9b9b9b;
  }
}

#mine-bar #mine-setting .disable-award {
  text-align: center;
  padding: 8px 8px;
  background: #9b9b9b;
  margin-top: 1rem;
  border-radius: 25px;
  color: #ea2d53;
}

#mine-bar #mine-setting .award {
  text-align: center;
  padding: 8px 8px;
  background: #ea2d53;
  margin-top: 1rem;
  border-radius: 25px;
  color: #ea2d53;
}

.precautions-dialog {
  ::v-deep .dialog-body {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
  }

  .precautions-title {
    color: #ea2d53;
    font-weight: bold;
    text-align: center;
    font-size: 18px;
    margin-top: 10px;
  }

  .precautions-context {
    text-align: left;
    margin: 7.5px 7.5px;
    line-height: 1.6;
    word-wrap: break-word;
    word-break: break-all;
    color: #666;
    font-size: 15px;
  }

  .precautions-tip-button {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    margin-top: 20px;
  }

  .precautions-tip-button button {
    min-height: 30px;
    line-height: 1.4;
    padding: 5px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: normal;
    word-break: break-all;
    font-size: 15px;
    width: 50%;
  }

  .precautions-tip-button .precautions-tip-cancel {
    background: #f5f5f5;
    color: #666;
  }

  .precautions-tip-button .precautions-tip-ok {
    background: #ea2d53;
    color: white;
  }
}

/* 收货信息容器 */
.receipt-info {
  margin-top: 5px;
  background: #fff;
  border-radius: 16rpx;
}

/* 每项信息 */
.receipt-info-item {
  padding: 2px 0;
  font-size: 15px;
  display: flex;
  align-items: center;
  color: #ea2d53; /* 红色文字 */
  letter-spacing: 1px; /* 字间距 */
  font-weight: bold;
  text-align: left;
}

/* 标签文字 */
.label {
  width: 80px;
}

/* 值文字 */
.value {
  flex: 1;
}

.tip-dialog {
  ::v-deep .dialog-body {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
  }
}

.tip-title {
  color: #ea2d53;
  font-weight: bold;
  text-align: center;
  font-size: 18px;
}

.tip-dialog .tip-context {
  text-align: left;
  margin: 15px;
  line-height: 1.6;
  word-wrap: break-word;
  word-break: break-all;
  font-size: 15px;
  color: #666;
}

.tip-dialog .tip-button {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 40px;
}

.tip-dialog .tip-button button {
  min-height: 30px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: normal;
  word-break: break-all;
  font-size: 14px;
  width: 50%;
}

.tip-dialog .tip-button .tip-cancel {
  background: #f5f5f5;
  color: #666;
}

.tip-dialog .tip-button .tip-ok {
  background: #ea2d53;
  color: white;
}

.line {
  height: 2px; /* 横线高度，即粗细 */
  background-color: #ea2d53; /* 横线颜色 */
  width: 100%;
  margin: 10px 0; /* 上下间距 */
}
</style>
